import script from "./SessionTimeoutModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionTimeoutModal.vue?vue&type=script&setup=true&lang=js"

import "./SessionTimeoutModal.vue?vue&type=style&index=0&id=2c3b5c99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c3b5c99"]])

export default __exports__